// plugins/phosphor-icons.ts
import { defineNuxtPlugin } from '#app'
import * as PhosphorIconsVue from '@phosphor-icons/vue'

export default defineNuxtPlugin((nuxtApp) => {
  for (const [key, component] of Object.entries(PhosphorIconsVue)) {
    nuxtApp.vueApp.component(key, component)
  }
})
